import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetBeacon4RagThresholds } from '../requests/Beacon4PerformanceRequests';

// Month name → number map
const MONTH_NUM = {
	Jan:1, Feb:2, Mar:3, Apr:4, May:5, Jun:6,
	Jul:7, Aug:8, Sep:9, Oct:10, Nov:11, Dec:12
};

export const loadBeacon4Rag = createAsyncThunk(
	'beacon4Rag/load',
	async ({ side, polygon }, { rejectWithValue }) => {
		try {
			const res = await GetBeacon4RagThresholds({ side, polygon: polygon || undefined });
			return res?.data ?? res;
		} catch (e) {
			return rejectWithValue(e.response?.data ?? e.message);
		}
	}
);

// Convert RAG points array into { 'YYYY-MM': { dssrGreen, dssrRed, ... } }
function buildRagMap(points) {
	const map = {};
	for (const p of points) {
		const monthNum = MONTH_NUM[p.month] ?? parseInt(p.month);
		const key      = `${p.year}-${String(monthNum).padStart(2, '0')}`;
		map[key] = p;
	}
	return map;
}

const beacon4RagSlice = createSlice({
	name: 'beacon4Rag',
	initialState: {
		ragMap:  {},   // { 'YYYY-MM': RagPoint }
		loading: false,
		error:   null,
	},
	reducers: {
		clearBeacon4Rag(state) { state.ragMap = {}; },
	},
	extraReducers: (b) => {
		b.addCase(loadBeacon4Rag.pending,   (s) => { s.loading = true;  s.error = null; })
			.addCase(loadBeacon4Rag.fulfilled, (s, a) => {
				s.loading = false;
				s.ragMap  = buildRagMap(a.payload ?? []);
			})
			.addCase(loadBeacon4Rag.rejected,  (s, a) => { s.loading = false; s.error = a.payload; });
	},
});

export const { clearBeacon4Rag } = beacon4RagSlice.actions;
export default beacon4RagSlice.reducer;
export const selectBeacon4RagMap = (state) => state.beacon4Rag.ragMap;